import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";

import './PromotersPromoterInfo.sass';
import { currencies } from "../../../../constants/currencies";
import { updatePromoter } from "../../../../store/actions/promotersActions";

class PromotersPromoterInfo extends Component {
  state = {
    promoter: { id: null },
    isSaveDisabled: true,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.currentPromoter.id &&
      props.currentPromoter.id !== state.promoter.id) {

        const promoter = {
          ...props.currentPromoter,
          currency: currencies.find(
            (option) => option.value === props.currentPromoter.currencyId
          ),
          feeRate: props.currentPromoter.feeRate * 100
        };
      return {
        promoter,
      };
    } else {
      return null;
    };
  };

  handleChangePromoterData = (e) => {
    let { name, value } = e.target;
    
    const { ...promoter } = this.state.promoter;

    if (name === "fixedFeeRate" || name === "feeRate") {
      if (value[0] === "-") {
        value = "-" + value.replace(/[^\d.]/g, '');
      } else {
        value = value.replace(/[^\d.]/g, '');
      };

      if (name === "feeRate" && (+value > 100 || value === '-')) {
        return;
      }
    };

    promoter[name] = value;

    this.setState({ promoter, isSaveDisabled: false });
  }

  handleChangeCurrency = (value) => {
    const { ...promoter } = this.state.promoter;

    promoter.currency = value;

    this.setState({
      promoter,
      isSaveDisabled: false,
    });
  };

  updatePromoter = () => {
    const token = this.props.user.token;
    const id = this.props.match.params.promoterId;
    const { currency, feeRate, fixedFeeRate, ...promoter } = this.state.promoter;
    const data = {
      ...promoter,
      currencyId: currency.value,
      fixedFeeRate: fixedFeeRate || 0,
      feeRate: feeRate / 100 || 0,
    }

    this.props.updatePromoter(token, id, data)
      .then(() => this.setState({ isSaveDisabled: true }));
  };

  render() {
    const { promoter, isSaveDisabled } = this.state;

    return (
      <div className="promoter-info">
        <div className="promoter-info__main">
          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Promoter name</label>

                <input
                  type="text"
                  name="name"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter name"
                  value={promoter.name}
                  onChange={this.handleChangePromoterData}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Email</label>
                <span className="add-event__block__count">
                  {promoter.email}
                </span>
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Address</label>

                <input
                  type="text"
                  name="address"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter address"
                  value={promoter.address}
                  onChange={this.handleChangePromoterData}
                />
              </div>
            </div>
          </div>
          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Company name</label>

                <input
                  type="text"
                  name="companyName"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter company name"
                  value={promoter.companyName}
                  onChange={this.handleChangePromoterData}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Website</label>

                <input
                  type="text"
                  name="website"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter website"
                  value={promoter.website}
                  onChange={this.handleChangePromoterData}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Phone</label>

                <input
                  type="text"
                  name="phone"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter phone"
                  value={promoter.phone}
                  onChange={this.handleChangePromoterData}
                />
              </div>
            </div>
          </div>
          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Currency</label>

                <Select
                  options={currencies}
                  name="currency"
                  classNamePrefix="custom-select"
                  value={promoter.currency}
                  onChange={this.handleChangeCurrency}
                  className="custom-select"
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Fixed fee rate, {promoter.currency ? promoter.currency.label : ''}</label>

                <input
                  type="text"
                  name="fixedFeeRate"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter fixed fee rate"
                  value={promoter.fixedFeeRate}
                  onChange={this.handleChangePromoterData}
                />
              </div>
            </div>
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Fee rate, %</label>

                <input
                  type="text"
                  name="feeRate"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter fee rate"
                  value={promoter.feeRate}
                  onChange={this.handleChangePromoterData}
                />
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Prefix</label>

                <span className="add-event__block__count">
                  {promoter.prefix}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="promoter-info__actions">
          <button
            type="button"
            className="btn-primary btn-primary--save"
            onClick={this.updatePromoter}
            disabled={isSaveDisabled}
          >
            <span>Save</span>
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  auth: { user },
  promoters: { loading, currentPromoter }
}) => ({ user, loading, currentPromoter });

const mapDispatchToProps = (dispatch) => ({
  updatePromoter: (token, id, data) => dispatch(updatePromoter(token, id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromotersPromoterInfo);